/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 15:42:04
 * @LastEditTime: 2021-06-10 17:43:21
 * @LastEditors: wangshengqiang
 * @Description: 手机号
 */
import { withProps } from '@/hoc';
import { validateNumber } from '@/validator/proValidator.js';
import RowInput from '../RowInput';
export default withProps(RowInput, {
  // maxLength: 11,
  // inputType: 'number',
  rules: [{
    validator: validateNumber
  }]
});